<div class="card mb-3">
  <div class="card-body">
    <p class="font-weight-bold text-blue h5" i18n="laf|Statement tabs@@laf.statement.tabs.baggage.recentEvents">
      Recent events
    </p>
    <div class="font-small text-dark-gray" *ngFor="let log of logs">
      <span class="font-weight-bold">{{ log.dt | date: 'dd.MM.yyyy HH:mm' : 'UTC+0' }} ZT</span>{{ log.text }}
    </div>
  </div>
</div>